import { createContext, useContext } from 'react';
const RecommendationsListActivityContext = /*#__PURE__*/createContext(false);
export const RecommendationsListActivityProvider = RecommendationsListActivityContext.Provider;
export const useIsRecommendationsListActive = () => useContext(RecommendationsListActivityContext);
//# sourceMappingURL=RecommendationsListActivity.js.map